import { render, staticRenderFns } from "./LayoutDashboardIcon.vue?vue&type=template&id=05c935fa"
import script from "./LayoutDashboardIcon.vue?vue&type=script&lang=js"
export * from "./LayoutDashboardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports